import { Bell, RefreshCw, Calendar, Wrench, ArrowLeftRight, CheckCircle2, XCircle, Trash2, Send, Gift, Heart, ShoppingCart, Sparkles } from 'lucide-react'
import type { NotificationType, NotificationConfig } from './types'

export const notificationConfig: Record<NotificationType, NotificationConfig> = {
  announcement: {
    icon: Bell,
    bgColor: "bg-blue-500/10",
    borderColor: "border-blue-500/20",
    textColor: "text-blue-500"
  },
  update: {
    icon: RefreshCw,
    bgColor: "bg-green-500/10",
    borderColor: "border-green-500/20",
    textColor: "text-green-500"
  },
  event: {
    icon: Calendar,
    bgColor: "bg-purple-500/10",
    borderColor: "border-purple-500/20",
    textColor: "text-purple-500"
  },
  maintenance: {
    icon: Wrench,
    bgColor: "bg-yellow-500/10",
    borderColor: "border-yellow-500/20",
    textColor: "text-yellow-500"
  },
  trade_request: {
    icon: ArrowLeftRight,
    bgColor: "bg-primary/10",
    borderColor: "border-primary/20",
    textColor: "text-primary"
  },
  trade_accepted: {
    icon: CheckCircle2,
    bgColor: "bg-green-500/10",
    borderColor: "border-green-500/20",
    textColor: "text-green-500"
  },
  trade_rejected: {
    icon: XCircle,
    bgColor: "bg-destructive/10",
    borderColor: "border-destructive/20",
    textColor: "text-destructive"
  },
  trade_cancelled: {
    icon: XCircle,
    bgColor: "bg-yellow-500/10",
    borderColor: "border-yellow-500/20",
    textColor: "text-yellow-500"
  },
  card_removed: {
    icon: Trash2,
    bgColor: "bg-destructive/10",
    borderColor: "border-destructive/20",
    textColor: "text-destructive"
  },
  item_sent: {
    icon: Send,
    bgColor: "bg-blue-500/10",
    borderColor: "border-blue-500/20",
    textColor: "text-blue-500"
  },
  item_received: {
    icon: Gift,
    bgColor: "bg-emerald-500/10",
    borderColor: "border-emerald-500/20",
    textColor: "text-emerald-500"
  },
  wishlist_card_found: {
    icon: Heart,
    bgColor: "bg-pink-500/10",
    borderColor: "border-pink-500/20",
    textColor: "text-pink-500"
  },
  store_sale: {
    icon: ShoppingCart,
    bgColor: "bg-blue-500/10",
    borderColor: "border-blue-500/20",
    textColor: "text-blue-500"
  },
  series_eternized: {
    icon: Sparkles,
    bgColor: "bg-amber-500/10",
    borderColor: "border-amber-500/20",
    textColor: "text-amber-500"
  }
} 